@file:UseSerializers(UuidSerializer::class)

package it.neckar.lizergy.model.configuration.quote.builder

import it.neckar.lizergy.lifeCycle.LizergyHasLifeCycle
import it.neckar.lizergy.lifeCycle.LizergyLifeCycleState
import it.neckar.lizergy.model.energy.BatteryCapacity
import it.neckar.uuid.HasUuid
import it.neckar.uuid.UuidSerializer
import it.neckar.uuid.randomUuid4
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseSerializers
import kotlin.uuid.Uuid

/**
 * Describes a battery storage extension.
 * Extends a battery system
 */
@Serializable
data class BatteryStorageExtensionType(
  /**
   * The UUID
   */
  val id: BatteryStorageExtensionTypeId,

  /**
   * The description for the battery storage
   */
  val description: String,

  /**
   * The amount of energy that can be stored
   */
  val storageCapacity: BatteryCapacity,
  val usableStorageCapacity: BatteryCapacity,

  val numberOfBatteryModules: Int,

  /**
   * Contains the list of batteries this is an extension for.
   * Usually this list is empty.
   */
  val extensionFor: Set<BatteryStorageType>,

  override val lifeCycleState: LizergyLifeCycleState = LizergyLifeCycleState.Active,

  ) : HasUuid, LizergyHasLifeCycle {

  override val uuid: Uuid
    get() {
      return id.uuid
    }

  /**
   * An id for a battery storage type
   */
  @Serializable
  data class BatteryStorageExtensionTypeId(val uuid: Uuid) {

    override fun toString(): String {
      return uuid.toString()
    }

    fun format(): String {
      return uuid.toString()
    }

    companion object {
      fun random(): BatteryStorageExtensionTypeId {
        return BatteryStorageExtensionTypeId(randomUuid4())
      }
    }
  }
}
